import { SchemaDeSerBuilder, type SchemaDeSer } from "./deser"

export enum QuoteAlertTriggerType {
  Last = "Last",
  Bid = "Bid",
  Ask = "Ask",
  IV = "IV",
}

export enum QuoteAlertOperator {
  GreaterThan = ">",
  LessThan = "<",
}

function parseTriggerType(value: string): QuoteAlertTriggerType | null {
  return (
    Object.values(QuoteAlertTriggerType).find((type) => type === value) ?? null
  )
}

function parseOperator(value: string): QuoteAlertOperator | null {
  switch (value) {
    case QuoteAlertOperator.GreaterThan:
      return QuoteAlertOperator.GreaterThan
    case QuoteAlertOperator.LessThan:
      return QuoteAlertOperator.LessThan
    default:
      return null
  }
}

export class QuoteAlert {
  instrumentType: string | null = null
  operator: QuoteAlertOperator | null = null
  triggeredAt: Date | null = null
  threshold: string | null = null
  thresholdNumeric = NaN
  alertExternalId: string | null = null
  dxSymbol: string | null = null
  provider: string | null = null
  completedAt: Date | null = null
  dismissedAt: Date | null = null
  createdAt: Date | null = null
  symbol: string | null = null
  field: QuoteAlertTriggerType | null = null
  userExternalId: string | null = null
  expiresAt: Date | null = null
}

export interface QuoteAlertCreateParams {
  field: QuoteAlertTriggerType
  operator: QuoteAlertOperator
  threshold: string
  thresholdNumeric: number
  symbol: string
  dxSymbol: string
}

export const QUOTE_ALERT_DESER: SchemaDeSer<QuoteAlert> =
  new SchemaDeSerBuilder(QuoteAlert)
    .ofStrings(
      "threshold",
      "dxSymbol",
      "provider",
      "symbol",
      "alertExternalId",
      "userExternalId"
    )
    .ofNullableString("instrumentType")
    .ofFloat("thresholdNumeric")
    .ofDateTime("createdAt")
    .ofDateTime("triggeredAt")
    .ofDateTime("dismissedAt")
    .ofDateTime("completedAt")
    .ofDateTime("expiresAt")
    .ofCustomEnum("operator", "operator", parseOperator)
    .ofCustomEnum("field", "field", parseTriggerType)
    .toDeSer()
